import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DocumentPreview from "./documentpreview";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../Utils/toastContext";

const DocumentHistory = ({ currentDoc, onClose }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();

  const [filter, setFilter] = useState(7);
  const [historyData, sethistoryData] = useState([]);
  const [selectedDoc, setselectedDoc] = useState({});
  const [isFileOpen, setisFileOpen] = useState(false);
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "Last 7 days",
  });
  const navigate = useNavigate();
  const handleFileOpen = (file) => {
    setselectedDoc(file);
    setisFileOpen(true);
  };
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFilter(selectedOption.value);
    setpreSelectedFilter(selectedOption);
  };
  const formatDateTime = (dateString) => {
    const [datePart, timePart, meridian, timezone] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");

    // Convert 24-hour format to 12-hour format
    const hours12 = (+hours % 12 || 12).toString();
    const formattedTime = `${hours12}.${minutes}${meridian}`;
    return `${formattedTime} | ${day}/${month}/${year}`;
  };
  const filterOptions = [
    { value: 7, label: "Last 7 days" },
    { value: 30, label: "Last 30 days" },
  ];
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getDocHistory = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/document/history/${currentDoc.document_id}?days=${filter}`
      );

      if (response.status == 200) {
        sethistoryData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getDocHistory();
  }, [currentDoc.document_id, filter]);
  return (
    <div className="fixed inset-0 flex  items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-3xl p-6 relative  h-[90vh] md:h-auto overflow-auto md:overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          {/* Heading with Icon */}
          <div className="flex items-center space-x-2">
            <img
              src="/backward-10-seconds.svg"
              alt="Document Icon"
              className="h-6 w-6"
            />
            <h2 className="text-lg font-medium">
              Document History:{" "}
              <span className="font-medium text-[#8C8C8C]">
                {currentDoc.unique_id}
              </span>
            </h2>
          </div>

          <div className="flex items-center space-x-4">
            {/* Filter Dropdown */}
            <Dropdown
              label=""
              options={filterOptions}
              preselectedValue={preSelectedFilter}
              onSelect={handleFilterChange}
            />
            {/* <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="border font-medium rounded-lg px-3 py-1 text-sm"
            >
              {filterOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select> */}

            {/* Close Button */}
            <button
              onClick={onClose}
              className="text-black text-xl font-bold hover:text-gray-700 flex items-center space-x-2"
            >
              {/* Icon */}
              <img src="/add.svg" alt="Close Icon" className="h-10 w-10" />
            </button>
          </div>
        </div>

        {/* History Items */}
        <div className="space-y-4 h-[80vh] overflow-y-auto">
          {historyData.map((item, index) => (
            <div
              key={index}
              className={`p-4 rounded-md ${
                index % 2 === 0 ? "bg-blue-50" : "bg-gray-50"
              }`}
            >
              <div className="flex items-center">
                {/* User Avatar */}
                <div className="h-10 w-10 rounded-full bg-gray-300 flex-shrink-0">
                  <img
                    src="/avatar.svg"
                    alt="Close Icon"
                    className="h-10 w-10"
                  />
                </div>

                {/* Content */}
                <div className="ml-4">
                  <p className="text-sm">
                    <span className="font-medium">
                      {item.added_by.first_name + item.added_by.last_name}
                    </span>{" "}
                    <span className="text-sm text-blue-600">
                      {item.added_by.role}
                    </span>{" "}
                    <span className="text-[#8C8C8C]">
                      has uploaded a new Document to{" "}
                    </span>
                    <span className="font-medium">{item.unique_id}</span>.
                  </p>
                  <p className="text-xs mt-2 text-gray-500 flex items-center space-x-2">
                    {/* Time Icon */}
                    <img
                      src="/backward-10-seconds.svg"
                      alt="Time Icon"
                      className="h-4 w-4"
                    />
                    <span>{formatDateTime(item.uploaded_at)}</span>
                  </p>
                  <button
                    onClick={() => handleFileOpen(item)}
                    className="mt-2 px-4 py-1 text-sm bg-white border rounded-md shadow-sm hover:bg-gray-100"
                  >
                    {item.file_name}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="bg-white border-black border  text-black px-10 py-2 rounded-full"
          >
            Close
          </button>
        </div>
      </div>
      {isFileOpen && selectedDoc && (
        <DocumentPreview
          fileUrl={selectedDoc.file_path}
          fileName={selectedDoc.file_name}
          onClose={() => setisFileOpen(false)}
        />
      )}
    </div>
  );
};

export default DocumentHistory;
